import React, { useState } from "react";
import classes from './Lodgement.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Download } from "lucide-react";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
const Lodgement = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const data = [
        {
            lodgement: "BL-001",
            date: "2025-01-15",
            bank: "First Bank",
            accountNumber: "1100300400",
            amount: "₦1,200,000.00",
            references: "Customer Payment - Dangote",
            type: "Customer Payment",
            status: "Completed",
        },
        {
            lodgement: "BL-001",
            date: "2025-01-15",
            bank: "First Bank",
            accountNumber: "1100300400",
            amount: "₦1,200,000.00",
            references: "Customer Payment - Dangote",
            type: "Customer Payment",
            status: "Pending",
        },
        {
            lodgement: "BL-001",
            date: "2025-01-15",
            bank: "First Bank",
            accountNumber: "1100300400",
            amount: "₦1,200,000.00",
            references: "Customer Payment - Dangote",
            type: "Customer Payment",
            status: "Completed",
        },
        {
            lodgement: "BL-001",
            date: "2025-01-15",
            bank: "First Bank",
            accountNumber: "1100300400",
            amount: "₦1,200,000.00",
            references: "Customer Payment - Dangote",
            type: "Customer Payment",
            status: "Pending",
        },
        {
            lodgement: "BL-001",
            date: "2025-01-15",
            bank: "First Bank",
            accountNumber: "1100300400",
            amount: "₦1,200,000.00",
            references: "Customer Payment - Dangote",
            type: "Customer Payment",
            status: "Completed",
        },
        {
            lodgement: "BL-001",
            date: "2025-01-15",
            bank: "First Bank",
            accountNumber: "1100300400",
            amount: "₦1,200,000.00",
            references: "Customer Payment - Dangote",
            type: "Customer Payment",
            status: "Completed",
        },
    ];




    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}
                        onClick={() => navigate('/transactions/sales-invoice/sale')}>Sales Invoice</button>
                    <button className={classes.btns}
                        onClick={() => navigate('/inventory/PurchaseOrder')}>Purchase Invoice</button>
                    <button className={classes.btnsq}>Bank Lodgement</button>
                    <button className={`${classes.btns} ${classes.greens}`}
                        onClick={() => navigate('/settings/product-services')}>Product & Services</button>
                </div>
                <header className={classes.Header}>
                    <h2 className={classes.Title}>Bank Lodgement</h2>
                    <h1 className={classes.Titles}>
                        Record and monitor all bank deposits and lodgements efficiently.</h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total lodgement</p>
                                <p className={classes.kdptg1}>₦5,000,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Cleared</p>
                                <p className={classes.kdptg2}>₦1,200,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Confirmed</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Pending</p>
                                <p className={classes.kdptg3}>₦1,200,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Awaiting clearance</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Transactions</p>
                                <p className={classes.kdptg4}>28</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBar} placeholder="Search lodgements..." />
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                        </div>

                        <div className={classes.dropdownWrapper}>
                            <select className={classes.statusDropdown}>
                                <option>All Banks</option>
                                <option>Cash</option>
                                <option>Cheque</option>
                                <option>Transfer</option>
                            </select>
                            <span className={classes.arrowDown}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.filterInput} placeholder="Filter" />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>

                    <div className={classes.actionsLeft}>
                        <button className={classes.outlineBtn}>
                            <Download size={16} style={{ marginRight: "6px" }} />
                            Export
                        </button>
                        <button className={classes.greenBtn}>
                            + New lodgement
                        </button>
                    </div>

                </div>


                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr>
                                <th>Lodgement#</th>
                                <th>Date</th>
                                <th>Bank</th>
                                <th>Account Number</th>
                                <th>Amount</th>
                                <th>References</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.lodgement}</td>
                                    <td>{row.date}</td>
                                    <td>{row.bank}</td>
                                    <td>{row.accountNumber}</td>
                                    <td style={{ textAlign: 'right' }}>{row.amount}</td>
                                    <td>{row.references}</td>
                                    <td>{row.type}</td>

                                    <td>
                                        <span className={`${classes.statusBadge} ${row.status === "Completed"
                                            ? classes.statusCompleted
                                            : row.status === "Pending"
                                                ? classes.statusPending
                                                : ""
                                            }`}>
                                            {row.status}
                                        </span>
                                    </td>
                                    <td className={classes.action}>
                                        <Eye size={16} style={{ marginRight: "8px", color: 'rgba(22, 163, 74, 1)' }} />
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>
            </div>
            <Footer />
        </div>
    );
};

export default Lodgement;

